import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${() => `${viewSizeCalculator(1)}`}; // 1rem

  width: 22%;
  height: 100%;
`;

export const ScrollWrapper = styled.div`
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  // padding: ${() => `${viewSizeCalculator(2)}`} 0;

  overflow-x: auto;
  position: relative;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 0px; // Width of the vertical scrollbar
    //height: 4px; // Height of the horizontal scrollbar
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; // Light gray background for the scrollbar track
    border-radius: 4px; // Rounded corners for the track
  }

  &::-webkit-scrollbar-thumb {
    background: #3333334d; // Light gray color for the scrollbar thumb
    border-radius: 4px; // Rounded corners for the thumb
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #33333380; // Darker gray color when hovering over the scrollbar thumb
  }
`;

export const Container = styled.div`
  padding: ${() =>
    `${viewSizeCalculator(0.625)} ${viewSizeCalculator(
      0.625,
    )}`}; // 0.625rem 1.25rem;

  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #ffffff;

  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
`;
